import React, { useEffect, useState } from "react";
import CustomLoader from "../../components/CustomeLoader";
import { status } from "../../_constants/commonLhd";
import { pageAction } from "../../_actions";
import { useDispatch, useSelector } from "react-redux";

const Privacy = () => {
  const [loader, setLoading] = useState(true);
  const pageData = useSelector((state) => state.page);
  const [page, setPage] = useState({});
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 300);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 300);
  }, []);

  useEffect(() => {
    dispatch(pageAction.getPages());
  }, []);

  useEffect(() => {
    if (pageData && pageData.page_status === status.SUCCESS) {
      setPage(pageData.page_data);
    }
  }, [pageData.page_data]);

  return (
    <>
      {loader ? (
        <CustomLoader />
      ) : (
        <div className="containts-page-section">
          <div className="container">
            <div className="text-center">
              <h1>{page.Name}</h1>
            </div>

            <div
              className="company-name"
              dangerouslySetInnerHTML={{
                __html: page?.Content || "<p>No terms available.</p>",
              }}
            ></div>
          </div>
        </div>
      )}
    </>
  );
};

export default Privacy;
